import SmileDefault from '../../assets/icons/smiley-default-happy.svg';
import SmileInactive from '../../assets/icons/smiley-inactive-happy.svg';
import SmileSelected from '../../assets/icons/smiley-selected-happy.svg';

interface Props {
  state?: 'default' | 'inactive' | 'selected';
  className?: string;
}

export const Smile = ({ state = 'default', className }: Props) => {
  return (
    <img
      src={
        state === 'default' ? SmileDefault : state === 'inactive' ? SmileInactive : SmileSelected
      }
      alt="Smile"
      className={`${className || 'h-8 w-8'}`}
    />
  );
};
